import React from 'react';
// import PropTypes from 'prop-types';
import styles from 'styles/components/lib/buttons/buttons.css';

const Button = ({label, children, className, status, style, value, ...props}) => {
  let classes = [styles.button].concat(className, status).join(' ');
  return (
    <button type="button" className={classes} style={style} value={value ? value : label} {...props} >
      { label && <span>{label}</span> }
      { children }
    </button>
  );
}

const PrimaryButton = ({children, ...props}) => (
  <Button  className={styles.primaryButton} {...props}>
    {children}
  </Button>
);

const LinkButton = ({children, ...props}) => (
  <Button  className={styles.linkButton} {...props}>
    {children}
  </Button>
);

export {Button, PrimaryButton, LinkButton};



// WEBPACK FOOTER //
// ./src/scripts/components/lib/buttons/Button.js